export const SENTRY_DSN: string = 'https://f6446e5ef52240288ad3a6e6f664fd42@sentry.uncinc.nl/71';

export const MAP_ZOOM: { [key: string]: number } = {
  MAX: 18,
  MIN: 10,
  DEFAULT: 15,
}

export const GOOGLE_MAPS_SEARCH_LINK = 'https://www.google.com/maps/search/';
